import { Trans } from '@lingui/macro'
import { authRoles } from 'app/auth/authRoles'
import { RouteConfig } from 'app/router/Routes'
import { EgretLoadable } from 'egret'
import { FORMS_PATHS } from './formsConstants'

const Forms = EgretLoadable({
  loader: async () => await import('../internal/Forms')
})

const Form = EgretLoadable({
  loader: async () => await import('./Form')
})

const FormEditor = EgretLoadable({
  loader: async () => await import('./editor/FormWizard')
})

const OpportunityViewWithForm = EgretLoadable({
  loader: async () => await import('./OpportunityViewWithForm')
})

const formsRoutes: RouteConfig[] = [
  {
    path: FORMS_PATHS.FORMS,
    component: Forms,
    auth: authRoles.pm,
    isTranslatable: true,
    label: <Trans>FORMS_ROUTES_FORMS_LABEL</Trans>,
    showCollapseBtn: true,
    collapseByDefault: true
  },
  {
    path: `${FORMS_PATHS.FORM_EDITOR}/:id?`,
    component: FormEditor,
    auth: authRoles.pm,
    isTranslatable: true,
    label: <Trans>FORMS_ROUTES_FORM_EDITOR_LABEL</Trans>,
    showCollapseBtn: true,
    collapseByDefault: true
  },
  {
    path: `${FORMS_PATHS.PREVIEW_FORM}/:formId/:id?/:previewType?`,
    component: Form,
    auth: authRoles.editor
  },
  {
    path: `${FORMS_PATHS.OPPORTUNITY_FORM_VIEW}/:formId/:opportunityId/:objectId/:printConfig?`,
    component: OpportunityViewWithForm
  }
]

export default formsRoutes
